// import { useContext } from 'react';
import { useContext } from 'use-context-selector';
import { UserContext } from 'Contexts/UserContext';

export default function useUser() {
  return useContext(UserContext);
}
